export enum TipoLembreteAssinaturaDigital {
    NAO_ENVIAR = "NAO_ENVIAR",
    A_CADA_1_DIA = "A_CADA_1_DIA",
    A_CADA_2_DIAS = "A_CADA_2_DIAS",
    A_CADA_5_DIAS = "A_CADA_5_DIAS",
    A_CADA_20_DIAS = "A_CADA_20_DIAS",
    A_CADA_30_DIAS = "A_CADA_30_DIAS",
}

export const getLembreteFormatado = (tipoLembrete: TipoLembreteAssinaturaDigital) => {
    switch (tipoLembrete) {
        case TipoLembreteAssinaturaDigital.NAO_ENVIAR:
            return 'Não enviar lembrete';
        case TipoLembreteAssinaturaDigital.A_CADA_1_DIA:
            return 'A cada 1 dia';
        case TipoLembreteAssinaturaDigital.A_CADA_2_DIAS:
            return 'A cada 2 dias';
        case TipoLembreteAssinaturaDigital.A_CADA_5_DIAS:
            return 'A cada 5 dias';
        case TipoLembreteAssinaturaDigital.A_CADA_20_DIAS:
            return 'A cada 20 dias';
        case TipoLembreteAssinaturaDigital.A_CADA_30_DIAS:
            return 'A cada 30 dias';
        default:
            return tipoLembrete;
    }
};
